export default {
  data () {
    return {
      meta: {},
      currentPage: 1,
    };
  },
  methods: {
    setMeta (meta) {
      this.meta = meta;
    },
    changePage () {

    },
    resetToFirstPage () {
      this.filters.page = 1;
    },
  },
  computed: {
    isShowPagination () {
      return this.meta && this.meta.total;
    },
  },
};
